export const commonSwiperConfig = {
  preventClicks: true,
  preventClicksPropagation: true,
};
